/*
 * @Author: dongyue23
 * @Date: 2020-11-23 14:36:37
 * @LastEditTime: 2021-04-08 15:48:23
 * @LastEditors: dongyue23
 * @Description: 东东企业家App jsBridge
 * @FilePath: /jdd_qyjr_h5/src/utils/bridge.js
 */

// 临时存储在桥梁可用前的调用，等准备就绪之后立刻调用
let calls = []
let addCallbacks = []

// 桥梁准备就绪的回调钩子列表
let readyCallbacks = []

export const bridge = {
  _bridge: null, // js与终端的桥梁对象
  available: false, // 桥梁是否准备完毕并可用

  // 桥梁准备就绪触发的回调函数
  ready(callback) {
    this.available ? callback() : readyCallbacks.push(callback)
  },

  /**
     * js调用native公开的函数
     * @param  {string}   functionName   native公开的函数名
     * @param  {Object}   params     传递给native的参数
     * @param  {function} callback 回调函数，接受responseData参数
     */
  call(functionName, params, callback) {
    if (!functionName) return

    if (!this.available) {
      calls.push({
        name: functionName,
        params,
        callback
      })

      return
    }

    this._bridge.callHandler(functionName, params, callback || (() => {}))
  },

  /**
     * 将js函数注册到native，native会在未来某时刻触发此事件
     * @param  {string} functionName   js函数名
     * @param  {function} callback 事件钩子，接受responseData参数
     */
  addCallback(functionName, callback) {
    if (!functionName) return

    if (!this.available) {
      addCallbacks.push({
        name: functionName,
        callback
      })
      return
    }

    this._bridge.registerHandler(functionName, callback || (() => {}))
  }
}

function connectWebViewJavascriptBridge(callback) {
  if (!isJBFApp()) {
    return
  }
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge)
    return
  }
  document.addEventListener('WebViewJavascriptBridgeReady', () => {
    callback(window.WebViewJavascriptBridge)
  }, false)

  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  const WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'https://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(() => { document.documentElement.removeChild(WVJBIframe) }, 0)
}

function initializeBridge(_bridge) {
  _bridge.init && _bridge.init()
  readyCallbacks.forEach((item) => {
    item()
  })

  calls.forEach((item) => {
    bridge.call(item.name, item.params, item.callback)
  })

  addCallbacks.forEach((item) => {
    bridge.addCallback(item.name, item.callback)
  })

  readyCallbacks = []
  calls = []
  addCallbacks = []
}

connectWebViewJavascriptBridge((_bridge) => {
  bridge._bridge = _bridge
  bridge.available = true
  initializeBridge(_bridge)
})

// 判断是否是东东企业家App
export function isJBFApp() {
  var ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('jbfapp') > -1
}

/**
 * @description: 简化JsBridge调用
 * @param {*} nativeFn: 原生API名称
 * @param {*} paramData: 入参
 * @return {*} Promise对象
 */
export function asyncCall(nativeFn, paramData) {
  const data = {
    name: nativeFn,
    param: paramData
  }
  return new Promise((resolve, reject) => {
    try {
      bridge.call('jbf_openNative:callback:', data, (resultData) => {
        resolve(resultData)
      })
    } catch (e) {
      reject(e)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/JBFAPPbridge.js